import React from 'react';
import SEO from '../components/SEO';
import ServiceLayout from '../components/ServiceLayout';

const DemosPage: React.FC = () => {
  return (
    <>
      <SEO
        title="Equipment Trials & On-Site Demos"
        description="On-site demo equipment installation so your clinical team can evaluate ergonomics, reach, and workflow before committing to a final selection."
        keywords="healthcare equipment demo, hospital equipment trial, on-site medical equipment demo, clinical equipment evaluation, equipment trial installation"
        url="https://www.jvphealthtechsolutions.com/services/demos"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Equipment Trials & On-Site Demos",
          "description": "On-site equipment trials and demos for clinical teams to evaluate ergonomics, reach, and workflow compatibility.",
          "provider": { "@type": "Organization", "name": "JVP Health Tech Solutions" },
          "areaServed": "US"
        }}
      />
      <ServiceLayout
        title="Trials & Demos"
        subtitle="Try before you commit — evaluate real equipment in your actual clinical environment."
        pageImage="/images/services/demos-d4a06f6e.jpg"
        pageImageAlt="Demo equipment installed for evaluation"
        ctaText="Request a Demo"
        summary="We install demo equipment on-site so your clinical team can test ergonomics, reach, and workflow compatibility in real-world conditions — before you commit to a full deployment."
        sections={[
          {
            title: 'Why On-Site Trials Matter',
            body: 'Spec sheets and showroom demos only tell part of the story. Seeing equipment in your actual rooms, with your actual staff, changes the conversation.',
            items: [
              'Validate ergonomics and reach in your real clinical environment',
              'Test workflow compatibility with existing equipment and room layouts',
              'Get hands-on feedback from nurses, physicians, and support staff',
              'Compare multiple solutions side-by-side before committing',
              'Reduce the risk of costly equipment changes after full deployment',
              'Build staff confidence and buy-in before go-live',
            ],
          },
          {
            title: 'How Trials Work',
            body: 'A simple, low-commitment process that gives your team the information they need to make the right call.',
            items: [
              'We identify the best demo equipment based on your facility\'s needs',
              'Demo units are installed in representative rooms or departments',
              'Clinical staff use the equipment during normal workflows',
              'We collect feedback and provide recommendations for final selection',
            ],
          },
        ]}
      />
    </>
  );
};

export default DemosPage;
